/**
 * useMenuPreference + useAvailableMenuLayouts (Etap C, ADR-0031).
 *
 * `useMenuPreference` — GET /api/auth/menu-preference (own preferowany layoutId).
 * `useAvailableMenuLayouts` — GET /api/auth/menu-preference/available (lista
 *   layoutów dostępnych dla aktualnego usera, do switchera w sidebarze).
 */

import type { MenuLayoutSummary } from '@saas/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export const MENU_PREFERENCE_KEY = ['auth', 'menu-preference'] as const;
export const AVAILABLE_MENU_LAYOUTS_KEY = ['auth', 'menu-preference', 'available'] as const;

export interface MenuPreferenceResponse {
  layoutId: string | null;
}

export interface AvailableMenuLayoutsResponse {
  layouts: MenuLayoutSummary[];
}

export function useMenuPreference() {
  return useQuery<MenuPreferenceResponse>({
    queryKey: MENU_PREFERENCE_KEY,
    queryFn: async () => {
      const res = await api.get<MenuPreferenceResponse>('/auth/menu-preference');
      return res.data;
    },
    staleTime: 30_000,
  });
}

export function useAvailableMenuLayouts() {
  return useQuery<AvailableMenuLayoutsResponse>({
    queryKey: AVAILABLE_MENU_LAYOUTS_KEY,
    queryFn: async () => {
      const res = await api.get<AvailableMenuLayoutsResponse>('/auth/menu-preference/available');
      return res.data;
    },
    staleTime: 30_000,
  });
}
